import {Injectable} from '@angular/core';
import {GraphKnDataService} from './graph-kn.data.service';
import { Edge, IConnectorsEdges,  IGraphData,  ITagretsNodes, TGraphType } from '../models/graph-kn.model-interfaces';
import { Vector2d } from 'konva/lib/types';
import { BUSINESS_PROCESS_LAYER_ID, CONTRACT_LAYER_ID, Orientation } from '../models/graph-kn.cm-api-models';
import { ARROW_POINTER_MARGIN, ARROW_START_MARGIN } from '../models/graph-kn.cm.arrows-model-const';
import { Position } from '../models/graph-kn.model-enums';
import { RectModelsMap } from '../styles/graph-node-rect-model';

@Injectable({
    providedIn: 'root'
})
export class GraphKnEdgesConnectorsService {
	constructor(
		private knDataService: GraphKnDataService,
	) { }

	generateConnectorsEdges(elements: IGraphData  | undefined, targetsNodes: ITagretsNodes[], topNodeYpos: number, layerId: TGraphType = BUSINESS_PROCESS_LAYER_ID,): IConnectorsEdges[] {
		let connectorsEdges: IConnectorsEdges[] = []
        let rectModel = RectModelsMap.get(layerId === 'bpLayer'? 'BPStatus' : 'contractStep')
        elements!.edges.forEach(edge=> {
			let nodeHeight = this.knDataService.nodeHeight || rectModel!.height
			let nodeWidth = this.knDataService.nodeWidth || rectModel!.width
			let contaractEdgePoints: Vector2d[] = []
			let BPEdgePoints: Vector2d[] = (edge as Edge).points
			let from = targetsNodes.find(el => el.node.id === edge.source)
			let to = targetsNodes.find(el => el.node.id === edge.target)

			if (from && to && layerId === CONTRACT_LAYER_ID) {
                contaractEdgePoints = [
                    {x: from.x + this.knDataService.nodeWidth + ARROW_START_MARGIN, y: from.y + rectModel!.height! / 2},
                    {x: to.x - ARROW_POINTER_MARGIN, y: to.y + rectModel!.height! / 2}
                ];
            
                connectorsEdges.push({
                    id: 'connector-' + connectorsEdges.length,
                    nodeType:from.node.nodeType,
                    fixedFromToPositions:true,
                    from: edge.source.toString(),
                    fromRelativePos:{x:nodeWidth!,y:nodeHeight!/2},
                    fromEdgePos:Position.Right,
                    to: edge.target.toString(),
                    toRelativePos:{x:0,y:nodeHeight!/2},
                    toEdgePos: Position.Left,
                    //toRelativePos:contaractEdgePoints.at(0)?.y === contaractEdgePoints.at(-1)?.y? {x:0,y:nodeHeight/2} : {x:nodeWidth/2,y:0},
                    //toEdgePos:contaractEdgePoints.at(0)?.y === contaractEdgePoints.at(-1)?.y? Position.Left : Position.Top,
                    points: contaractEdgePoints,
                    points_labels: contaractEdgePoints,
                    data: edge.data,
                    moveAlg: (edge as Edge).moveAlg,
                    active: (edge as Edge).active
                });
            }
            
            if (from && to && layerId === BUSINESS_PROCESS_LAYER_ID) {
                let points = edge.points_labels
                let fromRelativePos:Vector2d = {
                x:points[0].x - (from?.x||0),
                y:points[0].y - (from?.y||0),
                }
                let toRelativePos:Vector2d = {
                x:(points.at(-1)?.x||0) - (to?.x||0),
                y:(points.at(-1)?.y||0) - (to?.y||0),
                }
                let lenX = (points.at(-1)?.x||0) - points[0].x
                let lenY = (points.at(-1)?.y||0) - points[0].y
                
                let fromEdgePos:Position = this.calcEdgePosition(fromRelativePos,nodeHeight!,nodeWidth!)
                let toEdgePos:Position = this.calcEdgePosition(toRelativePos,nodeHeight!,nodeWidth!)

                let relativePointsData:number[] = [1,1]
                edge.points_labels.forEach((p:any,ind:number)=>{
                if ([0,points.length-1].includes(ind) === false) {
                    relativePointsData.push( Math.abs((points[0].x - p.x)/lenX))
                    relativePointsData.push( Math.abs((points[0].y - p.y)/lenY))
                }
                })
                relativePointsData = [...relativePointsData,1,1]
                connectorsEdges.push({
                    id: 'connector-' + connectorsEdges.length,
                    nodeType:from.node.nodeType,
                    edge_id:edge.id,
                    from: edge.source.toString(),
                    fromRelativePos:fromRelativePos,
                    fromEdgePos:fromEdgePos,
                    to: edge.target.toString(),
                    toRelativePos:toRelativePos,
                    toEdgePos:toEdgePos,
                    points: BPEdgePoints,
                    points_labels: (edge as Edge).points_labels,
                    relativePointsData:relativePointsData,
                    data: edge.data,
                    moveAlg: (edge as Edge).moveAlg,
                    active: (edge as Edge).active
                });
            }
		})
		return connectorsEdges;
	}

	calcEdgePosition(edgeShift:Vector2d, nodeHeight:number,nodeWidth:number, graphDirection:Orientation = Orientation.LEFT_TO_RIGHT):Position {
		let position:Position = Position.Left;
		edgeShift.x === 0 ? position =  Position.Left : null;
		edgeShift.y === 0 ? position =  Position.Top : null;
		edgeShift.x === nodeWidth ? position =  Position.Right : null;
		edgeShift.y === nodeHeight ? position =  Position.Bottom : null;
		return position
	}
}